module.exports = __webpack_public_path__ + "static/media/site_web.7a17403e.png";